<template>
<div>
    <div class="nav-tabs-container pt-1">
        <div class="nav-tabs-scroll-helper">
            <ul class="nav nav-tabs">

                <li class="nav-item">
                    <a class="nav-link" :class="{'active': mode == 'all'}" href id="tabLinkWorkLocations1" role="tab" aria-controls="tabContentWorkLocations1" :aria-selected="mode == 'all'" @click.prevent="mode = 'all'; $bus.$emit('resize')">
                        {{ allWorkLocationsLabel || 'All Items' }} ({{ allWorkLocationCount }})
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" :class="{'active': mode == 'selected'}" href id="tabLinkWorkLocations2" role="tab" aria-controls="tabContentWorkLocations1" :aria-selected="mode == 'selected'" @click.prevent="mode = 'selected'; $bus.$emit('resize')">
                        {{ selectedWorkLocationsLabel || 'Selected' }} ({{ selectedWorkLocationCount }})
                    </a>
                </li>

            </ul>
        </div>
    </div>

    <div class="flex-body flex-container tab-content work-location-selector">
        <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'all'}" id="tabContentWorkLocations1" role="tabpanel" aria-labelledby="tabLinkWorkLocations1">
            <fast-table
                v-if="mode == 'all'"
                :sections="workLocationSections"
                :headers="workLocationHeaders"
                :data="workLocationTableData"
                @click="onWorkLocationClick"
                @select="onWorkLocationSelect"
                @filter-edit-open="$emit('filter-edit-open')"
                @filter-edit-close="$emit('filter-edit-close')"
                :use-overlay-filter-editor="true"
                :has-row-select="true"
                :show-search="true"
                :show-filter="false"
                :show-more-actions="false"
            />

        </div>

        <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'selected'}" id="tabContentWorkLocations2" role="tabpanel" aria-labelledby="tabLinkWorkLocations2">
            <fast-table
                v-if="mode == 'selected'"
                :sections="workLocationSections"
                :headers="workLocationHeaders"
                :data="selectedWorkLocationTableData"
                @click="onWorkLocationClick"
                @select="onWorkLocationSelect"
                @filter-edit-open="$emit('filter-edit-open')"
                @filter-edit-close="$emit('filter-edit-close')"
                :use-overlay-filter-editor="true"
                :has-row-select="true"
                :show-search="true"
                :show-filter="false"
                :show-more-actions="false"
            />

        </div>

    </div>
</div>
</template>

<script>
import FastTable from '@/components/FastTable'

export default {
    props: ['allWorkLocations', 'companies', 'modelValue', 'allWorkLocationsLabel', 'selectedWorkLocationsLabel', 'employeeCountsByLocationId', 'lockedLocationIds'],
    emits: ['update:modelValue', 'filter-edit-open', 'filter-edit-close'],
    components: {FastTable, },
    data() {
        let data = {
            mode: 'all',
            formData: {
                workLocations: Array.from(this.modelValue),
            },
            workLocationHeaders: [
                    {label: 'Location', classes: 'cell-company', defaultSort: true, isFilterable: true, isSearchable: true, },
                    {label: 'Warnings', classes: 'cell-narrow', isFilterable: false, isSearchable: false, },
                    {label: 'Employees', classes: 'cell-narrow', isFilterable: false, isSearchable: false, },
            ],
        }
        return data
    },
    computed: {
        lockedIdSet() {
            return new Set(this.lockedLocationIds || [])
        },
        workLocationSections() {
            let result = []
            let resultsByCompany = {}
            this.allWorkLocations.forEach(wl => {
                const company = this.companies.find(c => c.id == wl.company_id)
                if (!(company.name in resultsByCompany)) {
                    resultsByCompany[company.name] = {title: company.name, id: company.id}
                }
            })
            let sortedKeys = Object.keys(resultsByCompany).sort()
            sortedKeys.forEach(k => {
                result.push(resultsByCompany[k])
            })
            return result
        },
        workLocationTableData() {
            let result = []
            let resultsByCompany = {}
            this.allWorkLocations.forEach(wl => {
                if (!(wl.company.name in resultsByCompany)) {
                    resultsByCompany[wl.company.name] = []
                }
                resultsByCompany[wl.company.name].push({
                    id: wl.id,
                    isSelected: this.formData.workLocations.includes(wl.id),
                    selectDisabled: this.lockedIdSet.has(wl.id),
                    object: wl,
                    cells: [
                        wl.name,
                        '',
                        (this.employeeCountsByLocationId && this.employeeCountsByLocationId[wl.id] != null)
                            ? String(this.employeeCountsByLocationId[wl.id])
                            : '',
                    ],
                })
            })
            let sortedKeys = Object.keys(resultsByCompany).sort()
            sortedKeys.forEach(k => {
                result.push(resultsByCompany[k])
            })
            return result
        },
        selectedWorkLocationTableData() {
            let result = []
            this.workLocationTableData.forEach(companyWorkLocationTableData => {
                let companyResult = companyWorkLocationTableData.filter(row => {
                    return this.formData.workLocations.includes(row.object.id)
                })
                companyResult = JSON.parse(JSON.stringify(companyResult))
                companyResult.forEach(row => {
                    row.isSelected = true
                })
                result.push(companyResult)
            })
            return result
        },
        allWorkLocationCount() {
            return this.allWorkLocations.length
        },
        selectedWorkLocationCount() {
            return this.formData.workLocations.length
        },
    },
    watch: {
        allWorkLocations() {
            this.$bus.$emit('resize')
        }
    },
    mounted() {
        this.$bus.$emit('resize')
    },
    methods: {
        onWorkLocationSelect(rows) {
            const workLocations = new Set()
            rows.forEach(row => {
                workLocations.add(row.object.id)
            })
            this.lockedIdSet.forEach(id => workLocations.add(id))

            this.formData.workLocations = Array.from(workLocations)

            this.$emit('update:modelValue', this.formData.workLocations)
        },
        onWorkLocationClick(workLocation) {
            if (this.lockedIdSet.has(workLocation.id)) {
                return
            }
            if (this.formData.workLocations.includes(workLocation.id)) {
                this.formData.workLocations = this.formData.workLocations.filter(wlId => wlId != workLocation.id)
            }
            else {
                this.formData.workLocations.push(workLocation.id)
            }

            this.$emit('update:modelValue', this.formData.workLocations)
        },
    },
}

</script>

<style>
.work-location-selector .table-wrapper {
    max-height: 320px;
    min-height: 280px;
}
</style>
